import { useAuth } from '../contexts/AuthContext';
import { useNavigate, Link } from 'react-router-dom';
import { DarkModeToggle } from './DarkModeToggle';
import { useDarkMode } from '../contexts/DarkModeContext';

export default function Footer() {
  const { logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const { isDarkMode } = useDarkMode();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <footer className={`text-white p-4 hidden md:block transition-colors duration-200 ${
      isDarkMode ? 'bg-gray-800' : 'bg-green-800'
    }`}>
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center gap-6">
          <DarkModeToggle />
          <Link
            to="/privacy"
            className="text-white hover:text-gray-200 transition-colors duration-200 text-sm"
          >
            Privacy Policy
          </Link>
        </div>
        {isAuthenticated && (
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-green-700 dark:bg-gray-600 hover:bg-green-600 dark:hover:bg-gray-700 rounded transition-colors duration-200"
          >
            Log Out
          </button>
        )}
      </div>
    </footer>
  );
}
